<template>
    <div class="teamStatsSmall">
        <div class="statsCardLabel mb-4">
            <p class="stats-card-header">{{ translations.season }}</p>
            <div class="selectDiv">
                <select v-model="currentSeason" style="width: 100%; border-radius: 10px; padding: 8px 16px; border: 1px solid rgba(51, 51, 51, 0.25);">
                    <option v-for="(season) in cornerStats.seasons.teamStatistics" :value="season.id">
                        20{{ season.season.seasonYear.split("/")[0] }}/20{{ season.season.seasonYear.split("/")[1] }}
                    </option>
                </select>
            </div>
        </div>
        <div class="d-flex justify-content-between flex-wrap flex-lg-nowrap">
            <div class="statsCard d-flex justify-content-between mr-md-4">
                <div class="stats-card-header">{{ translations.corners }}</div><div class="stats-card-header" :key="corners">{{ corners }}</div>
            </div>
            <div class="statsCard d-flex justify-content-between">
                <div class="stats-card-header">{{ translations.corners_game }}</div><div class="stats-card-header" :key="cornersGame">{{ cornersGame }}</div>
            </div>
        </div>
    </div>
</template>

<script>

export default {
    name: 'goal-stats',
    props: {
        cornerStats: {
            type: Object,
            required: true,
        }, 
        translations: {
            type: Object,
            required: true,
        },

    },
    data: function () {
        return {
            currentSeason: this.cornerStats.seasons.currentSeason.id,
        }
       
    },
    
    computed: {
        corners() {
            return this.cornerStats.seasons.teamStatistics[this.currentSeason].corner_kicks.value
        },
        cornersGame() {
            return +(this.cornerStats.seasons.teamStatistics[this.currentSeason].corner_kicks.value/this.cornerStats.seasons.teamStatistics[this.currentSeason].standings.gamesPlayed).toFixed(2)
        },

    },
}

</script>